routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider) {

  $stateProvider
    .state('home.headerCore', {
      url: "headerCore",
      template: `<header-core sh-ctrl="shCtrl"></header-core>`
    });
}

export default routesConfig;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/header-core/header-core.config.js
 **/